'use client'

import React, { useCallback, useState } from 'react'
import dynamic from 'next/dynamic'
import { loginWindowOpen } from '~/store/slices/authentication'
import { LoginOauth } from '~/components/login/LoginOauth'
import { setUUID } from '~/lib/auth'
import { useAppDispatch } from '~/store/redux-store'
import { AuthToken } from '~/lib/AuthToken'

const LoginLayout = dynamic(() => import('~/components/login/LoginLayout'))

const OauthStartPage = () => {
  setUUID()
  const dispatch = useAppDispatch()
  const [showButton, setShowButton] = useState(true)

  const handleClick = useCallback(() => {
    AuthToken.remove()
    setShowButton(false)
    dispatch(loginWindowOpen({ user_token: null }))
  }, [dispatch])

  return <LoginLayout content={<LoginOauth showButton={showButton} onLoginButtonClick={handleClick} />} />
}

export default OauthStartPage
